import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import {
  AssignmentCustomerResponse,
  BASE_PERMISSIONS,
  baseAssignmentsSelectors,
  BaseCoreState,
  BaseCustomerInquiryOfferInterface,
  BaseFilterService,
  baseInquirySelectors,
  BaseInquiryService,
  BaseOfferStatus,
  BaseRolesService,
  BaseShiftIconsEnum,
  InquiryResponse,
  ShiftTimeAndFlexResponse,
  BaseApplication,
} from 'base';
import { BaseCustomerWorkCouncilStatusEnum } from '../../../../../shared/_enums/base-customer-work-council-status.enum';

@Component({
  selector: 'base-customer-inquiry-offers-list',
  templateUrl: './base-customer-inquiry-offers-list.component.html',
})
export class BaseCustomerInquiryOffersListComponent implements OnInit, OnDestroy {
  @Input() offers: BaseCustomerInquiryOfferInterface[] = [];
  @Input() shiftTimesWithFlex: (ShiftTimeAndFlexResponse & { index: number; label?: string })[] = [];
  @Output() scrollListDown: EventEmitter<any> = new EventEmitter<any>();

  inquiry: Partial<InquiryResponse> = {};
  assignmentInfo: AssignmentCustomerResponse;
  canAcceptOffers = false;
  isOfferPreselectionAllowed = false;
  hasAdminAssignmentsPermission = false;
  modalRef: NgbModalRef;
  offerStatuses = BaseOfferStatus;
  offerWorkCouncilStatuses = BaseCustomerWorkCouncilStatusEnum;
  baseShiftIconsEnum = BaseShiftIconsEnum;
  application: BaseApplication;

  private destroy$ = new Subject();

  constructor(
    public filterService: BaseFilterService,
    private rolesService: BaseRolesService,
    public baseInquiryService: BaseInquiryService,
    private store: Store<BaseCoreState>
  ) {}

  ngOnInit() {
    this.handlePermissions();
    this.selectAssignment();
    this.selectCustomerInquiry();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  trackByOffer(_: number, item: BaseCustomerInquiryOfferInterface) {
    return item.data.id;
  }

  onScrollDown(): void {
    this.scrollListDown.emit();
  }

  private selectAssignment() {
    this.store
      .select(baseAssignmentsSelectors.getAssignment)
      .pipe(
        takeUntil(this.destroy$),
        filter((state) => state.ok === true)
      )
      .subscribe((assignment) => {
        this.assignmentInfo = assignment?.data;
      });
  }

  private selectCustomerInquiry() {
    this.store
      .select(baseInquirySelectors.getCustomerInquiry)
      .pipe(
        takeUntil(this.destroy$),
        filter((state) => !!state.ok),
        map((state) => state.data as InquiryResponse)
      )
      .subscribe((inquiryData) => {
        this.inquiry = inquiryData;
      });
  }

  private handlePermissions() {
    this.hasAdminAssignmentsPermission = this.rolesService.hasCustomerFeaturePermission(
      BASE_PERMISSIONS.FEATURE_ADMIN_ASSIGNMENTS
    );
    this.canAcceptOffers = this.rolesService.hasCustomerFeaturePermission(BASE_PERMISSIONS.FEATURE_ACCEPT_OFFER);
    this.isOfferPreselectionAllowed =
      this.rolesService.hasAdminRole() ||
      this.rolesService.hasCustomerFeaturePermission(BASE_PERMISSIONS.FEATURE_PRESELECT_OFFERS);
  }
}
